import {
  AfterViewInit,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product, productsOfferingData } from './product';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';

@Component({
  selector: 'app-pyg-offering',
  templateUrl: './pyg-offering.component.html',
  styleUrls: ['./pyg-offering.component.scss'],
  imports: [TranslatePipe, GetDemoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PygOfferingComponent implements AfterViewInit {
  private readonly activatedRoute = inject(ActivatedRoute);

  public readonly products: Product[] = productsOfferingData;

  @ViewChildren('productRef') productsRef!: QueryList<ElementRef<HTMLElement>>;

  ngAfterViewInit(): void {
    const prod = this.products.find(
      (p) => p.productFragment === this.activatedRoute.snapshot.fragment,
    );

    if (prod) {
      const el = this.productsRef.find(
        (ref) => Number(ref.nativeElement.id.substring(4)) === prod.productId,
      );
      setTimeout(() => {
        el?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }, 100);
    }
  }
}
